import * as React from "react";
const SvgHome = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      fill="#6C737F"
      d="M10.495 4.461a1.937 1.937 0 0 1 2.51 0l5.812 4.94a1.937 1.937 0 0 1 .683 1.477v7.726a1.49 1.49 0 0 1-1.49 1.49h-2.385a1.49 1.49 0 0 1-1.49-1.49v-3.875a1.192 1.192 0 0 0-1.187-1.192h-2.396a1.192 1.192 0 0 0-1.187 1.192v3.875a1.49 1.49 0 0 1-1.49 1.49H5.49A1.49 1.49 0 0 1 4 18.604v-7.726a1.938 1.938 0 0 1 .683-1.476z"
    />
  </svg>
);
export default SvgHome;